import React, { Fragment, useEffect, useState } from "react";
import TablePagination from "@mui/material/TablePagination";

const CustomPagination = (props) => {
  const [pager, setPager] = useState({});
  const [page, setPage] = useState(props.initialPage || 0);
  const [rowsPerPage, setRowsPerPage] = useState(props.per_page || 10);

  useEffect(() => {
    if (props.items) {
      updatePager(page, rowsPerPage);
    }
  }, [props.items, page, rowsPerPage]);

  const updatePager = (currentPage, perPage) => {
    const totalItems = props.items;
    const pagePager = getPager(totalItems, currentPage, perPage);
    setPager(pagePager);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    props.onChangePage("page", newPage);
  };

  const handleRowsPerPageChange = (event) => {
    const newPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newPerPage);
    props.onChangePage("limit", newPerPage);
    setPage(0); // reset to first page when rows per page changes
  };

  const getPager = (totalItems, currentPage, pageSize) => {
    const totalPages = Math.ceil(totalItems / pageSize);
    let startPage, endPage;

    if (totalPages <= 3) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 2) {
        startPage = 1;
        endPage = 3;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 2;
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    const pages = [...Array(endPage + 1 - startPage).keys()].map(
      (i) => startPage + i
    );

    return {
      totalItems,
      currentPage,
      pageSize,
      totalPages,
      startPage,
      endPage,
      startIndex,
      endIndex,
      pages,
    };
  };

  console.log({ page });

  return (
    <Fragment>
      {pager.totalItems > 5 && (
        <TablePagination
          component="div"
          count={pager.totalItems}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 15, 20, 25]}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}
    </Fragment>
  );
};

export default CustomPagination;
